import { t } from "@/i18n-js/instance";
import type { usePendingConnections } from "@/react/hooks/usePendingConnections";

import type { ExpandableAccordionItem } from "../shared/ExpandableAccordion";
import { ExpandableAccordion } from "../shared/ExpandableAccordion";

interface PendingConnectionsProps {
  pendingConnectionsQuery: ReturnType<typeof usePendingConnections>;
}

export const PendingConnections = ({
  pendingConnectionsQuery,
}: PendingConnectionsProps) => {
  const pendingConnections = pendingConnectionsQuery.audience || [];
  const hasMorePending = Boolean(pendingConnectionsQuery.hasNextPage);

  const items = pendingConnections.map(item => ({
    id: `${item.id}`,
    person: item,
    type: "connection",
  })) as unknown as ExpandableAccordionItem[];

  return (
    <ExpandableAccordion
      title={t("members_directory.grow.requests")}
      items={items}
      totalCount={pendingConnectionsQuery.totalQueryAudience ?? 0}
      isLoading={Boolean(pendingConnectionsQuery.isLoading)}
      hasMore={hasMorePending}
      fetchNextPage={() => pendingConnectionsQuery.fetchNextPage()}
      isFetchingNextPage={Boolean(pendingConnectionsQuery.isFetchingNextPage)}
      testId="pending-connections-accordion"
      listTestId="pending-connections-list"
    />
  );
};
